const handleAttachFile = {
  toastrCreateTitle: 'Anexo Adicionado',
  toastrCreateMessage: 'O Anexo foi adicionado com sucesso.',
  toastrCreateErrorTitle: 'Erro',
  toastrCreateErrorMessage: 'Erro ao adicionar anexo',
  
  toastrEditTitle: 'Anexo Editado',
  toastrEditMessage: 'O Anexo foi Editado com sucesso.',
  toastrEditErrorTitle: 'Erro',
  toastrEditErrorMessage: 'Erro ao editar anexo',

  toastrDeleteTitle: 'Anexo Deletado',
  toastrDeleteMessage: 'O Anexo foi deletado com sucesso.',
  toastrDeleteErrorTitle: 'Erro',
  toastrDeleteErrorMessage: 'Erro ao deletar anexo',
};

export default handleAttachFile;